<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.3789 8.01884C11.5505 6.99372 13.45 6.99372 14.6215 8.01884C15.7931 9.04397 15.7931 10.706 14.6215 11.7312C14.4176 11.9096 14.1917 12.0569 13.9513 12.1733C13.2056 12.5341 12.5002 13.1716 12.5002 14V14.75M21.5 12.5C21.5 17.4706 17.4706 21.5 12.5 21.5C7.52944 21.5 3.5 17.4706 3.5 12.5C3.5 7.52944 7.52944 3.5 12.5 3.5C17.4706 3.5 21.5 7.52944 21.5 12.5ZM12.5 17.75H12.5075V17.7575H12.5V17.75Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgQuestion',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
